<template>
  <div class='coupon_item'>
    <div class='coupon_item_left'>
      <div class='coupone_title'>{{item.name}}</div>
      <div class='coupone_tip'>{{item.oilNumNames.length > 18 ? item.oilNumNames.substring(0, 18) + '...' : item.oilNumNames}}可用</div>
      <!-- <div class='coupone_tip'>{{item.beginTime}}至{{item.endTime}}可用</div> -->
      <div class='coupone_tip' v-if="item.validDayNum">{{item.validDayNum + '天内'}}可用</div>
      <div class='coupone_tip' v-else-if="item.beginTime && item.endTime">{{ `${item.beginTime.slice(0,10)} 至 ${item.endTime.slice(0,10)}` }}可用</div>
      <div class='coupone_tip' v-if="isShow">{{oilName}}专属</div>
    </div>
    <div class='coupon_item_right'>
      <div class='coupone_money'><span>¥</span>{{item.amount}}</div>
      <div class='coupone_tip'>满{{item.threshold}}可用</div>
    </div>
    <div class='coupone_fc' v-if="item.number > 1">{{item.number}}张</div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    },
    oilName: {
      type: String,
      default: ''
    },
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>
<style lang="less">
.coupon_item{
  width: 288px;
  height: 88px;
  margin: 0 5px 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background: url('https://web.nlktj.com/ty/merchant/persisMarket/coupon_bg.png');
  background-size: 99%;
  background-repeat: no-repeat;
  border-radius: 3px;
  line-height: 15px;
  .coupon_dash{
    position: absolute;
    right: 35%;
    top: -1px;
    height: 103%;
  }
  .coupone_fc{
    position: absolute;
    top: 0;
    right: 0;
    background: #3377FF;
    box-sizing: border-box;
    padding: 1px 4px;
    color: #fff;
    font-size: 12px;
    border-radius: 1px 2px 1px 1px;
  }
  .coupon_item_left{
    flex: 1;
    box-sizing: border-box;
    padding: 10px;
    .coupone_title{
      color: #333333;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
    }
  }
  .coupon_item_right{
    width: 30%;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .coupone_money{
      color: #FF7403;
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 6px;
      span{
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
  .coupone_tip{
    color: #999999;
    font-size: 10px;
  }
}
</style>